function isBrowserIE() {
  return (!document.attachEvent || typeof document.attachEvent === 'undefined' ? 'not-ie' : 'ie');
}

export default function ready(callback) {
  const loadedStates = ['complete', 'loaded', 'interactive'];
  if (loadedStates.includes(document.readyState) && document.body) {
    callback();
  } else if (isBrowserIE() === 'not-ie') {
    document.addEventListener('DOMContentLoaded', () => callback());
  } else {
    document.attachEvent('onreadystatechange', () => {
      if (loadedStates.includes(document.readyState)) {
        callback();
      }
    });
  }
}
